/** CSV export — unchanged from legacy TdsReportsCompliance */
export function exportDeductionRegisterCsv(rows, filenamePrefix = "tds_deduction_register") {
  const header = ["Employee", "Code", "Taxable Income", "Annual Tax", "Monthly TDS"];
  const lines = rows.map((row) =>
    [
      `"${(row.name || "").replace(/"/g, '""')}"`,
      `"${(row.code || "").replace(/"/g, '""')}"`,
      row.taxableIncome ?? 0,
      row.annualTax ?? 0,
      row.monthlyTds ?? 0,
    ].join(",")
  );
  const csv = [header.join(","), ...lines].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filenamePrefix}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function exportProjectionCsv(rows) {
  const header = ["Employee", "Code", "Projected Income", "Exemptions", "Taxable Income", "Tax Liability"];
  const lines = rows.map((row) =>
    [
      `"${(row.name || "").replace(/"/g, '""')}"`,
      `"${(row.code || "").replace(/"/g, '""')}"`,
      row.projectedIncome ?? 0,
      row.approvedExemptions ?? 0,
      row.taxableIncome ?? 0,
      row.taxLiability ?? 0,
    ].join(",")
  );
  const csv = [header.join(","), ...lines].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `tds_tax_projection_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function groupByField(rows, field, valueKey = "monthlyTds") {
  const map = new Map();
  rows.forEach((row) => {
    const key = row[field] || "Unassigned";
    const prev = map.get(key) || { label: key, count: 0, gross: 0, taxable: 0, tax: 0, tds: 0 };
    map.set(key, {
      label: key,
      count: prev.count + 1,
      gross: prev.gross + (row.grossIncome || row.projectedIncome || 0),
      taxable: prev.taxable + (row.taxableIncome || 0),
      tax: prev.tax + (row.annualTax || row.taxLiability || 0),
      tds: prev.tds + (row.monthlyTds || 0),
    });
  });
  return [...map.values()];
}

export function filterRegisterRows(rows, filters) {
  return rows.filter((row) => {
    if (filters.employeeId && row.id !== filters.employeeId) return false;
    if (filters.department && (row.department || "Unassigned") !== filters.department) return false;
    if (filters.regime && row.regime !== filters.regime) return false;
    if (filters.search) {
      const q = filters.search.toLowerCase();
      const hay = `${row.name || ""} ${row.code || ""}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}

export function buildDeductionRows(registerRows) {
  return registerRows.map((emp) => ({
    id: emp.id,
    name: emp.name,
    code: emp.code,
    department: emp.department,
    regime: emp.regime,
    grossIncome: emp.grossIncome ?? 0,
    taxableIncome: emp.taxableIncome ?? 0,
    annualTax: emp.annualTax ?? 0,
    monthlyTds: emp.monthlyTds ?? 0,
  }));
}

export function buildProjectionRows(registerRows) {
  return registerRows.map((emp) => {
    const approvedExemptions = Object.values(emp.exemptions || {}).reduce(
      (s, v) => s + (v || 0),
      0
    );
    return {
      id: emp.id,
      name: emp.name,
      code: emp.code,
      department: emp.department,
      regime: emp.regime,
      projectedIncome: emp.grossIncome ?? 0,
      approvedExemptions,
      taxableIncome: emp.taxableIncome ?? 0,
      taxLiability: emp.annualTax ?? 0,
      monthlyTds: emp.monthlyTds ?? 0,
    };
  });
}
